import { z } from "zod";
import { QueryParams } from "../../httpClient";
import { ShopifyPlanEnum } from "./common";

// ==================
// Query Parameter Types
// ==================

/** Query params for listing stores (Client) */
export interface ClientListStoresQueryParams extends QueryParams {
    limit?: number;
    cursor?: string;
}

// ==================
// Request Body Schemas
// ==================

/** Request body for creating a new store (Client) */
export const CreateStoreRequestSchema = z.object({
    url: z.string().min(1).max(255),
    title: z.string().min(1).max(255),
    shopify_plan: ShopifyPlanEnum.optional(),
});

export type CreateStoreRequest = z.infer<typeof CreateStoreRequestSchema>;

/** Request body for updating a store (Client) */
export const UpdateStoreRequestSchema = z.object({
    url: z.string().min(1).max(255).optional(),
    title: z.string().min(1).max(255).optional(),
    shopify_plan: ShopifyPlanEnum.nullable().optional(),
});

export type UpdateStoreRequest = z.infer<typeof UpdateStoreRequestSchema>;

